import FEEDBACK_CONSTANTS from '@/constants/feedbackConstants';

export default {
  heading: 'Съжаляваме, че статията не е била полезна. Бихте ли ни съобщили какво не е било наред?',
  text: '',
  form: {
    fields: [
      {
        type: 'checkbox',
        name: FEEDBACK_CONSTANTS.FEEDBACK_CATEGORY_NAME,
        items: [
          {
            label: 'Информацията, която търся, липсва',
            value: 'missing_information',
            name: FEEDBACK_CONSTANTS.FEEDBACK_CATEGORY_NAME
          },
          {
            label: 'Има фактологични грешки',
            value: 'factual_errors',
            name: FEEDBACK_CONSTANTS.FEEDBACK_CATEGORY_NAME
          },
          {
            label: 'Някои въпроси са неясни',
            value: 'not_clear',
            name: FEEDBACK_CONSTANTS.FEEDBACK_CATEGORY_NAME
          }
        ]
      },
      {
        name: FEEDBACK_CONSTANTS.FEEDBACK_NAME,
        placeholder: 'Дайте ни малко информация и ние ще подобрим тази статия.',
        type: 'textarea'
      }
    ],
    submit: {
      label: 'Изпрати'
    }
  }
};
